import GameLogPane from "./GameLogPane";

export default GameLogPane;
export { GameLogPane };
